'use strict';
/**
 * Message sent by a peer to another. The latter tries to connect the former to
 * peers contained in this message.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var MRequire =
/**
   * @param {string[]} peers The identifiers of peers that the sender
   * requests.
   */
function MRequire(peers) {
  _classCallCheck(this, MRequire);

  this.peers = peers;
  this.type = 'MRequire';
};

module.exports = MRequire;